"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _2 = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TextInputField =
/*#__PURE__*/
function (_react$default$Compon) {
  _inheritsLoose(TextInputField, _react$default$Compon);

  function TextInputField() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _react$default$Compon.call.apply(_react$default$Compon, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocused: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(e);
      }

      _this.setState({
        isFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var onBlur = _this.props.onBlur;

      if (onBlur) {
        onBlur(e);
      }

      _this.setState({
        isFocused: false
      });
    });

    return _this;
  }

  var _proto = TextInputField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        isFirst = _this$props.isFirst,
        isTouched = _this$props.isTouched,
        isValid = _this$props.isValid,
        label = _this$props.label,
        name = _this$props.name,
        value = _this$props.value,
        props = _objectWithoutPropertiesLoose(_this$props, ["isFirst", "isTouched", "isValid", "label", "name", "value"]);

    var isFocused = this.state.isFocused;
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_2.AnimatedInputLabel, {
      isFocused: value.length > 0 || isFocused,
      name: name
    }, label), _react.default.createElement(_.StyledTextInput, _extends({
      error: isTouched && !isValid,
      isValid: isValid,
      name: name,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      pt: value.length > 0 || isFocused ? '15px' : 0,
      touched: isTouched,
      value: value
    }, props)));
  };

  return TextInputField;
}(_react.default.Component);

var _default = TextInputField;
exports.default = _default;